import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { Col, Row } from "antd";

export function TermConditionContents() {
	const [ref] = useTrackVisibility();

	const _renderDefinitions = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Definitions</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					<b style={{ color: "#222222" }}>“Parties”</b> - The two parties entering into this agreement are
					&quot;Charterer&quot; and &quot;Charter Company&quot;.
				</RATypography>
				<RATypography variant="body3" color="#595959" top={20}>
					<b style={{ color: "#222222" }}>“Charterer”</b> - The individual or entity requesting the charter
					service.
				</RATypography>
				<RATypography variant="body3" color="#595959" top={20}>
					<b style={{ color: "#222222" }}>“Charter Company”</b> - The company providing the service known as
					Royal Air Charter.
				</RATypography>
			</>
		);
	};

	const _renderGeneral = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">General</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					This charter quote is aircraft specific; should the need arise to change the aircraft, the cost may
					vary accordingly. The charterer shall be informed of and approve, any such change before flight and
					the amount of additional cost, if any. The quote is based upon aircraft and crew availability and is
					valid for 24 hours. Upon acceptance of the terms and conditions listed herein, this document becomes
					a legal and binding contract between the two parties.
				</RATypography>
			</>
		);
	};

	const _renderPricePaymentCancellation = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Prices, Payment And Cancellation</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					All prices quoted herein are accurate on the date quoted, are subject to change without notice, and
					are valid for 24 hours. Quotes include a variable fuel surcharge. Three days before departure, the
					fuel surcharge will be recalculated and provided as a final quote price. Full payment via wire is
					due 48 hours prior to departure.
				</RATypography>
				<RATypography variant="body3" color="#595959" top={20}>
					All refunds will be issued by company check only. Any changes made to an international flight
					scheduled to depart within 24 hours will carry a $1200 change fee. A wire must be received no later
					than 48 hours from the day of departure to avoid payment being processed to a credit card provided
					for a hold only. All credit card holds for outstanding payments greater than 72 hours past departure
					day will be processed into a sale without notice.
				</RATypography>
				<Row
					style={{
						borderBottom: "1px solid var(--primary-500, #FFB11A)",
						padding: "14px 0px",
					}}
				>
					<Col span={12}>
						<RATypography variant="sub-heading3" color="#222222" top={10} right={8}>
							Cancellation period
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="sub-heading3" color="#222222" top={10}>
							Applicable fee
						</RATypography>
					</Col>
				</Row>
				<Row
					style={{
						borderBottom: "1px solid #E9E8E8",
						paddingBottom: "14px",
					}}
				>
					<Col span={12}>
						<RATypography variant="body2" color="#595959" top={14} right={8}>
							&gt; 2 weeks from Departure
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="body2" color="#222222" top={14}>
							No Penalty
						</RATypography>
					</Col>
				</Row>
				<Row
					style={{
						borderBottom: "1px solid #E9E8E8",
						paddingBottom: "14px",
					}}
				>
					<Col span={12}>
						<RATypography variant="body2" color="#595959" top={14} right={8}>
							Two weeks-48 hours from Departure
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="body2" color="#222222" top={14}>
							10% of Charter Cost
						</RATypography>
					</Col>
				</Row>
				<Row
					style={{
						borderBottom: "1px solid #E9E8E8",
						paddingBottom: "14px",
					}}
				>
					<Col span={12}>
						<RATypography variant="body2" color="#595959" top={14} right={8}>
							From 48 hours up to the Day of Departure
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="body2" color="#222222" top={14}>
							50% of Charter Cost
						</RATypography>
					</Col>
				</Row>
				<Row
					style={{
						borderBottom: "1px solid #E9E8E8",
						paddingBottom: "14px",
					}}
				>
					<Col span={12}>
						<RATypography variant="body2" color="#595959" top={14} right={8}>
							{"< 12 hours to Departure; No-show for Departure"}
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="body2" color="#222222" top={14}>
							100% of Charter Cost
						</RATypography>
					</Col>
				</Row>
				<Row
					style={{
						borderBottom: "1px solid #E9E8E8",
						paddingBottom: "14px",
					}}
				>
					<Col span={12}>
						<RATypography variant="body2" color="#595959" top={14} right={8}>
							Empty Leg Flight Quotes
						</RATypography>
					</Col>
					<Col span={12}>
						<RATypography variant="body2" color="#222222" top={14}>
							100% Non-refundable and Nontransferable
						</RATypography>
					</Col>
				</Row>
			</>
		);
	};

	const _renderCancellationPolicy = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Cancellation Policy for Peak Travel Days</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Cancellations for reservations that fall within peak travel periods are subject to a 100% penalty
					and are strictly nonrefundable and nontransferable. Peak travel days are defined as the five (5)
					calendar days before and after the following holidays: New Year’s Day, Christmas Day, Easter Sunday,
					Memorial Day, Labor Day, Fourth of July, Thanksgiving Day, and Super Bowl Sunday. By making a
					reservation that includes any of these dates, you acknowledge and accept that cancellations or
					modifications during this time frame will result in the full forfeiture of all payments made, with
					no exceptions.
				</RATypography>
			</>
		);
	};

	const _renderLatePassenger = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Late Passenger / No-Show Policy</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Passengers who arrive 60 minutes or more after the scheduled departure time are considered a “No
					Show.“ Royal Air Charter reserves the right to cancel the flight at that time without further
					obligation. In such cases, the full cost of the flight will be forfeited in accordance with our
					cancellation policy, and the reservation will be treated as nonrefundable and nontransferable. It is
					the responsibility of the passenger to arrive on time; failure to do so may result in the
					cancellation of the flight without recourse or compensation.
				</RATypography>
			</>
		);
	};

	const _renderLastMinuteBooking = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Last Minute Bookings</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Last Minute Bookings are defined as any flight scheduled to depart within 24 hours of the time of
					booking. All such bookings are subject to a 100% cancellation penalty effective immediately upon
					execution of the signed contract. Last Minute Bookings are strictly nonrefundable and
					nontransferable, and are not eligible for cancellation or modification under the standard
					cancellation policy. By confirming a Last Minute Booking, the client acknowledges and accepts full
					financial responsibility for the flight, regardless of any changes, delays, or cancellations
					initiated by the client.
				</RATypography>
			</>
		);
	};

	const _renderDocumentation = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Documentation</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Photo IDs are required prior to flight. Additionally, official travel documents (passports, visas,
					etc.) are the responsibility of each passenger and must be provided to Royal Air Charter no later
					than 3 full business days prior to departure day on all international flights. Complications and
					fees, if any, that arise during international travel, due to the lack of proper travel
					identification, are the sole responsibility of the charterer.
				</RATypography>
			</>
		);
	};

	const _renderItinenaryChanges = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Itinerary Changes & Transmittal Of Changes</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Itinerary changes are permitted, but subject to aircraft and crew availability and subject to price
					adjustment. Notification of changes and/or cancellations must be in writing and transmitted via
					email to{" "}
					<b style={{ color: "#222222" }}>
						<u>charter@royalair.com</u>
					</b>
					. Changes made with less than 24 hours’ notice from departure time may not be approved. Changes to
					any international flight, with less than 24 hours’ notice, may be charged a $1200 expedited document
					processing fee.
				</RATypography>
			</>
		);
	};

	const _renderWeatherPolicy = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Weather Policy</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Flight operations are subject to weather conditions and may be delayed, rerouted, rescheduled, or
					canceled at the sole discretion of Royal Air Charter or the flight crew if conditions are deemed
					unsafe or non-compliant with regulatory requirements. While every effort will be made to operate the
					flight as scheduled, safety is the top priority. In the event of a weather-related delay or
					cancellation, Royal Air Charter will work with the client to reschedule the flight when conditions
					permit. Any additional costs incurred due to weather-related changes—including but not limited to
					repositioning, additional crew costs, lodging, or alternate transportation—will be the
					responsibility of the client. Should a passenger choose to cancel or alter their flight schedule due
					to personal concerns about weather conditions, such changes will be subject to the standard
					cancellation policy as outlined in these Terms and Conditions.
				</RATypography>
			</>
		);
	};

	const _renderForceMajeure = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Force Majeure</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Royal Air Charter shall not be held liable for any delay, cancellation, failure to perform, or other
					disruption of service due to causes beyond its reasonable control. This includes, but is not limited
					to, acts of God, natural disasters, weather conditions, government actions, labor disputes, war,
					terrorism, pandemics, technical failures, or any other unforeseen event that makes it unsafe,
					impossible, or impractical to operate the scheduled flight. In such cases, Royal Air Charter
					reserves the right to delay, cancel, or reschedule the flight without liability, and the client
					shall remain responsible for any nonrefundable expenses incurred up to that point. Royal Air Charter
					will make reasonable efforts to notify the client of such events and to minimize disruptions when
					possible.
				</RATypography>
			</>
		);
	};

	const _renderResponsibility = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Responsibility</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Royal Air Charter shall not be liable for any injury, damage, loss, expense, indirect, special, or
					consequential damages, or other irregularity caused by the defect of any vehicle or conveyance, or
					the negligence of any company or person engaged in conveying the passenger or carrying out the
					arrangements for your trip or by accident, delay, flight schedule, change, cancellation, sickness,
					weather, strikes, war, quarantine, or any similar cause. Our liability shall, in any case, be
					limited to the amount paid to us, and any claim shall be adjudicated in and governed by the laws of
					the state of Michigan, in which we have our principal business location.
				</RATypography>
			</>
		);
	};

	const _renderSupplementalServicesAndExpenses = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Supplemental Services and Expenses</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Supplemental Services and Expenses are defined as any additional services or costs incurred in the
					safe and efficient execution of the trip. These may include, but are not limited to, additional
					catering, ground transportation, lodging, restaurant or entertainment expenses, itinerary changes,
					hangar fees, de-icing fees, overnight hangar charges, FBO after-hours call-out fees, special event
					fees, repositioning fees, and other similar charges. The client expressly agrees to pay for all such
					services and expenses at cost, over and above the originally quoted trip price. Furthermore, the
					client authorizes Royal Air Charter to charge the payment method provided at the time of booking for
					any and all such supplemental charges without prior notice.
				</RATypography>
			</>
		);
	};

	const _renderCateringAndGroundServices = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Catering & Ground Services</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					All catering and ground service requests must be submitted to{" "}
					<b style={{ color: "#222222" }}>
						<u>charter@royalair.com</u>
					</b>{" "}
					48 hours prior to departure. Complimentary catering is capped at $500 per booking. Brokered flights
					do not qualify for complimentary catering. For ground service requests, a valid credit card must
					accompany the request. Any requests made after this time may not be accommodated.
				</RATypography>
			</>
		);
	};

	const _renderBaggagePolicy = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Baggage Policy</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					All passenger baggage must be properly stowed in designated luggage compartments prior to departure.
					For safety and regulatory compliance, aisles and emergency exits must remain completely clear of all
					bags at all times. Any baggage that cannot be safely secured in the approved storage areas, or that
					would cause the aircraft to exceed its maximum takeoff weight, must be removed from the flight and
					shipped separately at the client’s sole expense. Royal Air Charter reserves the right to refuse
					excess or improperly stowed baggage to ensure the safety and operational limits of the aircraft.
				</RATypography>
			</>
		);
	};

	const _renderPartialComletionOfFlights = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Partial Completion Of Flights</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Royal Air Charter is not liable for expenses incurred for replacement transportation in the case of
					mechanicals, (in such cases, our charges apply only on portions of flight completed). If a flight
					does not reach its destination due to weather, charges apply to any destination reached and return
					flight of the aircraft and crew (with or without passengers) to home base, as quoted. In the case of
					mechanicals, Royal Air Charter may, at its option, and the agreement of the charterer, provide
					substitute transportation which shall be charged as an additional fee to the charterer. In such
					cases, Royal Air Charter&apos;s original charges apply only on portions of flight completed.
					OPERATIONAL Aircraft owned by Royal Air Charter are operated under{" "}
					<b style={{ color: "#222222" }}>FAA Part 135 Air Carrier Certificate #BUHA637C</b>. I hereby accept
					these terms for the above-referenced charter.
				</RATypography>
			</>
		);
	};

	return (
		<HomeContactContainer ref={ref}>
			<WrapperContent>{_renderDefinitions()}</WrapperContent>
			<WrapperContent>{_renderGeneral()}</WrapperContent>
			<WrapperContent>{_renderPricePaymentCancellation()}</WrapperContent>
			<WrapperContent>{_renderCancellationPolicy()}</WrapperContent>
			<WrapperContent>{_renderLatePassenger()}</WrapperContent>
			<WrapperContent>{_renderLastMinuteBooking()}</WrapperContent>
			<WrapperContent>{_renderDocumentation()}</WrapperContent>
			<WrapperContent>{_renderItinenaryChanges()}</WrapperContent>
			<WrapperContent>{_renderWeatherPolicy()}</WrapperContent>
			<WrapperContent>{_renderForceMajeure()}</WrapperContent>
			<WrapperContent>{_renderResponsibility()}</WrapperContent>
			<WrapperContent>{_renderSupplementalServicesAndExpenses()}</WrapperContent>
			<WrapperContent>{_renderCateringAndGroundServices()}</WrapperContent>
			<WrapperContent>{_renderBaggagePolicy()}</WrapperContent>
			<WrapperContent>{_renderPartialComletionOfFlights()}</WrapperContent>
		</HomeContactContainer>
	);
}

const HomeContactContainer = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 40px;
	border-radius: 12px;
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
`;
const Content = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
